// export const MAIN_API = "http://127.0.0.1:8000/api/v1";
export const MAIN_API = "https://api.rightsandroots.com/public/api/v1";
